import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ExerciseInfo extends Component {
    render() {
        const {placeholder, value, limit, counter, onChange} = this.props;

        return (
            <div className="sa-dialog-description">
                <input
                    className="sa-dialog-input"
                    onChange={onChange}
                    placeholder={placeholder}
                    value={value}
                    maxLength={limit}
                    type="text"/>
                <div className="sa-dialog-counter">{counter}</div>
            </div>
        );
    }
}

ExerciseInfo.propTypes = {
    limit: PropTypes.number,
    counter: PropTypes.number,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
};

export default ExerciseInfo;
